import {
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import { fetchWeeklyGroupReportService } from "../../../services/reportService";
import { getAllAgentsService } from "../../../services/agentService";
import { toast } from "react-toastify";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx"; // Import XLSX for Excel export

function WeeklyGroupLoanCollectionReport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loans, setLoans] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [page, setPage] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCollections, setTotalCollections] = useState();
  const [agents, setAgents] = useState([]);

  const initialValues = {
    fromDate: null,
    toDate: null,
    frequency: "",
    status: "pending",
    agent: "",
    customerName: "",
  };
  const [filters, setFilters] = useState(initialValues);
  const frequencies = ["daily", "weekly", "monthly"];
  const statuses = ["pending", "partial", "paid"];

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //   const handleFilter = () => {
  //     fetchPigmy();
  //     // Fetch or filter customer based on fromDate and toDate
  //   };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchLoans = async (values) => {
    try {
      setLoading(true);
      const getLoans = await fetchWeeklyGroupReportService(
        values.fromDate, // Formik values now being used
        values.toDate,
        page,
        rowsPerPage,
        values.collectionDay,
        values.status,
        values.agent,
        false
      );
      setLoans(getLoans?.groupCollections);
      setTotalCollections(getLoans?.totalCollections);
      setExcelData(getLoans?.excelData); // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  
  

  const handleExport = async () => {
    setExcelLoading(true);

    const getLoans = await fetchWeeklyGroupReportService(
      filters.fromDate,
      filters.toDate,
      page,
      rowsPerPage,
      filters.collectionDay,
      filters.status,
      filters.agent,
      true
    );

    const excelData = getLoans?.excelData || [];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Weekly Group Loan Report");

    worksheet.columns = [
      { header: "SL.NO", key: "SL.NO", width: 8 },
      { header: "Group Name", key: "Group Name", width: 25 },
      { header: "Agent Name", key: "Agent Name", width: 20 },
      { header: "Phone Number", key: "Phone Number", width: 14 },
      { header: "Loan Code", key: "Loan Code", width: 12 },
      { header: "Loan Amount", key: "Loan Amount", width: 15 },
      { header: "Frequency", key: "Frequency", width: 12 },
      { header: "Due Date", key: "Due Date", width: 12 },
      { header: "Collection Day", key: "Collection Day", width: 15 },
      { header: "Collection Amount", key: "Collection Amount", width: 18 },
      { header: "Collected Date", key: "Collected Date", width: 16 },
      { header: "Status", key: "Status", width: 12 },
    ];

    // Add rows
    excelData.forEach((row, index) => {
      const dataRow = worksheet.addRow({
        "SL.NO": index + 1,
        "Group Name": row?.group?.groupName || "",
        "Agent Name": row?.agent?.userName || "",
        "Phone Number": row?.group?.groupLeaderPhoneNumber || "",
        "Loan Code": row?.group?.loanCode || "",
        "Loan Amount": row?.group?.loanAmount || "",
        Frequency: row?.group?.frequency || "",
        "Due Date": moment(row?.dueDate).format("DD-MM-YYYY") || "",
        "Collection Day": row?.collectionDay || "",
        "Collection Amount": row?.collectionAmount || "",
        "Collected Date": row?.collectionDate
          ? moment(row.collectionDate).format("DD-MM-YYYY")
          : "-",
        Status: row?.status || "",
      });

      // Font styling for certain fields
      dataRow.getCell("Group Name").font = {
        bold: true,
        color: { argb: "FF6A1B9A" }, // Deep Purple
      };
      dataRow.getCell("Agent Name").font = {
        bold: true,
        color: { argb: "FF1E88E5" }, // Blue
      };
      dataRow.getCell("Loan Amount").font = {
        bold: true,
        color: { argb: "FF2E7D32" }, // Green
      };
      dataRow.getCell("Collection Amount").font = {
        bold: true,
        color: { argb: "FFC62828" }, // Red
      };
      dataRow.getCell("Phone Number").font = {
        bold: true,
        color: { argb: "FF00897B" }, // Teal
      };
    });

    // Style headers and align cells
    worksheet.eachRow((row, rowNum) => {
      row.eachCell((cell, colNum) => {
        if (rowNum === 1) {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF5252FF" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        } else {
          const centerCols = [1, 5, 6, 7, 8, 9, 10, 11, 12];
          const leftCols = [2, 3, 4];

          if (centerCols.includes(colNum)) {
            cell.alignment = { vertical: "middle", horizontal: "center" };
          } else if (leftCols.includes(colNum)) {
            cell.alignment = { vertical: "middle", horizontal: "left" };
          }
        }
      });
    });

    // Export the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "WeeklyGroupLoanCollectionReport.xlsx");

    setExcelLoading(false);
  };


  useEffect(() => {
    fetchAgents();
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchLoans(filters); // fetch loans based on initial filter values
  }, [page, rowsPerPage]); // re-fetch loans on page or rowsPerPage change

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">
                Weekly Group Loan Collection Report
              </Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // backgroundColor: "#f7f7ff",
              }}
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  setFilters(values);
                  fetchLoans(values); // Pass Formik values when filtering
                }}
              >
                {({ values, handleChange, setFieldValue, errors, touched }) => (
                  <Form>
                    <Box>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2" color="#333">
                            From Date
                          </Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            size="small"
                            value={values.fromDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{
                              borderRadius: "5px",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "5px",
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2" color="#333">
                            To Date
                          </Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            size="small"
                            value={values.toDate}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{
                              borderRadius: "5px",
                              backgroundColor: "#fff",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "5px",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Status</Typography>
                            <Select
                              size="small"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                            >
                              {statuses.map((status) => (
                                <MenuItem key={status} value={status}>
                                  {status}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2" color="#333">
                            Collection Day *
                          </Typography>
                          <Field
                            as={TextField}
                            size="small"
                            name="collectionDay"
                            select
                            fullWidth
                            error={
                              touched.collectionDay &&
                              Boolean(errors.collectionDay)
                            }
                            helperText={
                              touched.collectionDay && errors.collectionDay
                            }
                            sx={{
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "5px",
                              },
                            }}
                          >
                            <MenuItem value="sunday">Sunday</MenuItem>
                            <MenuItem value="monday">Monday</MenuItem>
                            <MenuItem value="tuesday">Tuesday</MenuItem>
                            <MenuItem value="wednesday">Wednesday</MenuItem>
                            <MenuItem value="thursday">Thursday</MenuItem>
                            <MenuItem value="friday">Friday</MenuItem>
                            <MenuItem value="saturday">Saturday</MenuItem>
                          </Field>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <Typography variant="body2" color="#333">
                            Agent
                          </Typography>
                          <FormControl fullWidth>
                            <Select
                              size="small"
                              name="agent"
                              value={values.agent}
                              onChange={handleChange}
                              sx={{
                                backgroundColor: "#fff",
                                borderRadius: "5px",
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "5px",
                                },
                              }}
                            >
                              {agents.map((agent) => (
                                <MenuItem key={agent._id} value={agent._id}>
                                  {agent.userName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4} textAlign="center">
                          <Typography variant="body2" color="#333">
                            Actions
                          </Typography>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<i className="fas fa-filter"></i>}
                            sx={{
                              borderRadius: "5px",
                              padding: "6px 12px",
                              marginRight: "10px",
                              backgroundColor: "#5252ff",
                              "&:hover": { backgroundColor: "#3b3bb3" },
                            }}
                          >
                            {loading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Generate"
                            )}
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={handleExport}
                            sx={{
                              borderRadius: "5px",
                              padding: "6px 12px",
                              backgroundColor: "green",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#006400" },
                            }}
                          >
                            {excelLoading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Download Excel"
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>

            <Box sx={{ mt: 2 }}>
              {" "}
              <TableContainer>
                <Table
                  sx={{
                    minWidth: 650,
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                      {[
                        "SL.NO",
                        "Agent Name",
                        "Customer Name",
                        "Phone Number",
                        "Loan Code",
                        "Loan Amount",
                        "Frequency",
                        "Due Date",
                        "Collection Day",
                        "Collection Amount",
                        "Collected Date",
                        "Status",
                      ].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            color: "#5252ff",
                            padding: "6px",
                            fontWeight: "bold",
                            borderBottom: "1px solid #e0e0e0",
                            textAlign: "center",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loans?.length > 0 ? (
                      loans.map((row, index) => {
                        const isOverdue =
                          new Date(row?.dueDate) < new Date() &&
                          row?.status === "pending";
                        return (
                          <TableRow
                            key={row._id}
                            sx={{
                              backgroundColor: isOverdue
                                ? "#8B0000"
                                : index % 2 === 0
                                ? "#fafafa"
                                : "#ffffff",
                              color: isOverdue ? "#ffffff" : "inherit",
                              borderRadius: "8px",
                              boxShadow: 1,
                            }}
                          >
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.agent?.userName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.groupName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.groupLeaderPhoneNumber}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.groupCode}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.loanAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.frequency}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {moment(row?.dueDate).format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionDay}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionDate
                                ? moment(row.collectionDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : "-"}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color:
                                  row?.status === "pending"
                                    ? "#ffffff"
                                    : "inherit",
                              }}
                            >
                              {row?.status === "paid" ||
                              row?.status === "partial" ? (
                                <Chip
                                  label={row?.status}
                                  sx={{
                                    backgroundColor:
                                      row?.status === "paid"
                                        ? "#4CAF50"
                                        : "#CC7000", // Green for paid, dark orange for partial
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    padding: "0 8px",
                                    height: "24px",
                                    fontSize: "12px",
                                  }}
                                  size="small"
                                />
                              ) : (
                                row?.status
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={12}
                          sx={{ textAlign: "center", padding: "16px" }}
                        >
                          No loans available in table
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={totalCollections}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Show"
                sx={{
                  "& .MuiTablePagination-actions": { margin: "0 12px" },
                  mt: 2,
                }}
              />
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default WeeklyGroupLoanCollectionReport;
